import { FormValues } from '../types/valuations';

export const getValuationPayload = (values: FormValues) => {
  if (!values.loqateId) {
    return {
      subBuilding: values.subBuilding,
      buildingName: values.buildingName,
      buildingNumber: values.buildingNumber,
      street: values.street,
      town: values.town,
      postcode: values.postcode,
      numBedrooms: parseInt(values.bedrooms, 10),
      propertyStyle: `${values.propertyStyle}${values.propertyType}`,
      propertyRelationship: values.relationship,
      valuationReason: values.valuationReason || undefined,
      timeframe: values.timeframe?.trim() || undefined,
      skipAvm: values.mode === 'agent',
    };
  }

  return {
    loqateId: values.loqateId,
    numBedrooms: parseInt(values.bedrooms, 10),
    propertyStyle: `${values.propertyStyle}${values.propertyType}`,
    propertyRelationship: values.relationship,
    valuationReason: values.valuationReason || undefined,
    timeframe: values.timeframe?.trim() || undefined,
    skipAvm: values.mode === 'agent',
  };
};

export const getCreateAndSendPayload = (values: any) => {
  return {
    name: values.name,
    email: values.email,
    telephone: `${values.phonePrefix}${values.phoneNumber}`,
    contactPreference: values.contactPreference,
    contactTimePreference: values.contactTimePreference,
    accounts: [values.accountNumber],
    ...getValuationPayload(values),
  };
};
